import {MenuUidVo} from '../../common/shared/api/gateway/enums/MenuUidVo.enum';
import {ShortcutHomeType} from '../generated/types';

export function createShortcutHomeType(menu_uid: MenuUidVo): ShortcutHomeType {
  return mapper[menu_uid];
}

const mapper: {
  [key in MenuUidVo]: ShortcutHomeType;
} = {
  [MenuUidVo.Taste]: ShortcutHomeType.Taste,
  [MenuUidVo.Webtoon]: ShortcutHomeType.Webtoon,
  [MenuUidVo.WebNovel]: ShortcutHomeType.WebNovel,
  [MenuUidVo.Book]: ShortcutHomeType.Book,
};
